import { CanActivateChildFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, of, switchMap, withLatestFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { getPriceOfferRequestStatus } from '@aaa/emember/store-price-offers';
import { RequestStatus } from '@aaa/emember/types';
import { getMobileRenewQuery, MobileRenewActions } from '../../../store/mobile-renew';
import { getMembershipLevels } from '../../../store/price-offers/helpers/membership-levels';

export const validateQueryParams: CanActivateChildFn = () => {
  const store = inject(Store);

  return store.select(getPriceOfferRequestStatus).pipe(
    filter((status) => [RequestStatus.FAILED, RequestStatus.SUCCESS].includes(status)),
    switchMap((status) => of(status).pipe(withLatestFrom(store.select(getMobileRenewQuery)))),
    map(([status, { level, rv }]) => {
      const levels = getMembershipLevels();
      if (status === RequestStatus.FAILED) {
        store.dispatch(MobileRenewActions.navigateTo({ status: 'error', errorCode: 'membershipInvalidLevel' }));

        return false;
      }

      if (level) {
        const result = levels.filter((l) => l.level.toUpperCase() === String(level).toUpperCase() && l.rv === rv);

        if (result.length === 0 && levels.length) {
          store.dispatch(MobileRenewActions.navigateTo({ status: 'error', errorCode: 'membershipInvalidLevel' }));

          return false;
        }
      }

      return true;
    }),
  );
};

export default validateQueryParams;
